<template>
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
    <div class="x_panel">
      <div class="x_title">
        <h2>Handed over date</h2>
        <ul class="nav navbar-right panel_toolbox">
          <li>
            <button
              class="btn btn-default po-tile-edit-button"
              @click="editHandedOverDateDialog = true"
              v-if="item.handedOverAt && item.status !== 'Shipped' &&
            (checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE))">
              <i class="fa fa-edit"></i> Edit
            </button>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
      <div
        class="x_content handedOverDateCardLoading"
        v-if="item.handedOverAt">
        <div class="tile-stats">
          <div class="icon">
            <i class="fa fa-calendar"></i>
          </div>
          <div class="count">{{ item.handedOverAt | moment('MMMM Do YYYY') }} </div>
          <h4><em>Added {{ item.statusHandedOverAt | moment("from", "now") }}</em></h4>
        </div>
      </div>
      <div
        class="x_content"
        v-else>
        <div class="tile-stats">
          <div class="row">
            <h3 class="text-center empty-title">PO has not been handed over yet.</h3>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Edit handed over date"
      :visible.sync="editHandedOverDateDialog">
      <el-form
        :model="editHandedOverDateForm"
        :rules="handedOverDateRules"
        ref="editHandedOverDateForm">
        <fieldset>
          <el-form-item
            prop="handedOverDate"
            label="Select the handed over date"
            required>
            <el-date-picker
              v-model="editHandedOverDateForm.handedOverDate"
              type="date"
              size="large"
              format="dd/MM/yyyy"
              :placeholder="poHandedOverDate">
            </el-date-picker>
          </el-form-item>
        </fieldset>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
        @click="editHandedOverDateDialog = false">Cancel</el-button>
        <el-button
          type="success"
          @click="submitEdithandedOverDate('editHandedOverDateForm')">Confirm</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import getFileUploadHeaders from '@/services/http-file-headers';
import * as groups from '@/js/user-groups';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    updates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      editHandedOverDateForm: {
        handedOverDate: '',
      },
      handedOverDateRules: {
        handedOverDate: [
          {
            type: 'date',
            required: true,
            message: 'Please pick a handed over date',
            trigger: 'change',
          },
        ],
      },
      editHandedOverDateDialog: false,
      billOfLadingUpdates: [],
    };
  },
  computed: {
    getGroups() {
      return groups;
    },
    ...mapGetters({
      getHandedOverDate: 'getHandedOverDate',
      getUser: 'getUser',
    }),
    poHandedOverDate() {
      return `The PO was handed over at ${String(new Date(this.getHandedOverDate).toLocaleDateString())}`;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
  },
  created() {
    for (let i = 0; i < this.updates.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(this.updates[i], 'handedOverAt') ||
      Object.prototype.hasOwnProperty.call(this.updates[i], 'billOfLading')) {
        this.billOfLadingUpdates.push(this.updates[i]);
      }
    }
  },
  methods: {
    checkUserGroup(group) {
      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()) {
            return true;
          }
        }
      }
      return true;
    },
    openEdithandedOverDate() {
      this.editHandedOverDateDialog = true;
    },
    submitEdithandedOverDate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const dateObj = {};
          dateObj.handedOverAt = moment(this.editHandedOverDateForm.handedOverDate).format('YYYY-MM-DD');
          dateObj.poId = this.item.id;
          this.$store.dispatch('updateStatus', dateObj);
          this.editHandedOverDateDialog = false;
        }
        return false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-title {
  margin: 50px 0;
}
.download-file-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoHandedOverDate.vue